module.exports = __webpack_public_path__ + "fox3.png";